export const CORE_PORTAL_ENTRY_SOUND =
  '/sounds/new_sounds/enter-portal-intro.mp3';
export const WARDEN_PORTAL_ENTRY_SOUND = '/sounds/new_sounds/time-travel.mp3';
export const WARDEN_ARRIVAL_SOUND = '/sounds/demi-boss-appeared.mp3';
export const CORE_FIGHT_INTRO_SOUND =
  '/sounds/new_sounds/epic-glitch-intro.mp3';
export const CORE_DIE_THROW_SOUND = '/sounds/new_sounds/boss-die-throw.mp3';

export const NON_LETHAL_ATTACK_SOUNDS = [
  '/sounds/die-attack-non-lethal.mp3',
  '/sounds/die-attack-non-lethal-2.mp3',
  '/sounds/die-attack-non-lethal-3.mp3',
  '/sounds/die-attack-non-lethal-4.mp3',
];

export const GUARDIAN_ATTACK_SOUNDS = {
  charge: '/sounds/core-charging-attack.mp3',
  wardenReleases: [
    '/sounds/short-energy-beam-shot.mp3',
    '/sounds/large-underwater-explosion-sound.mp3',
  ],
  minionRelease: '/sounds/new_sounds/minion-beam-attack.mp3',
  wardenContact: '/sounds/misc-sound-effect.mp3',
};

export const SOUND_EFFECTS = [
  CORE_PORTAL_ENTRY_SOUND,
  WARDEN_PORTAL_ENTRY_SOUND,
  WARDEN_ARRIVAL_SOUND,
  CORE_FIGHT_INTRO_SOUND,
  CORE_DIE_THROW_SOUND,
  '/sounds/corebound-heartbeat.wav',
  ...NON_LETHAL_ATTACK_SOUNDS,
  ...Object.values(GUARDIAN_ATTACK_SOUNDS).flat(),
  '/sounds/treasure_chest_reveal_2.mp3',
  '/sounds/attack.mp3',
  '/sounds/boss-dies.mp3',
  '/sounds/boss_enraged_levels_1-3.mp3',
  '/sounds/boss_enraged.mp3',
  '/sounds/boss_killed_player.mp3',
  '/sounds/boss_defeated_victory.mp3',
  '/sounds/charged-laser-sound.mp3',
  '/sounds/dice-decrease-power.mp3',
  '/sounds/dice-hits-board.mp3',
  '/sounds/dice-increase-power.mp3',
  '/sounds/dice-roll-throw.mp3',
  '/sounds/digital-technology-beep.mp3',
  '/sounds/epic-get-ready.mp3',
  '/sounds/entering_single_player_game.mp3',
  '/sounds/fast-swoosh.mp3',
  '/sounds/futuristic_spinning.mp3',
  '/sounds/futuristic-zoom.mp3',
  '/sounds/glitch_core_die_settled.mp3',
  '/sounds/glitch_core_misc_sound_2.mp3',
  '/sounds/go-back.mp3',
  '/sounds/intro_to_corebound.mp3',
  '/sounds/large-underwater-explosion-sound.mp3',
  '/sounds/low-frequency-dice-impact.mp3',
  '/sounds/menu-select.mp3',
  '/sounds/menu-select-2.mp3',
  '/sounds/menu-select-3.mp3',
  '/sounds/menu-select-4.mp3',
  '/sounds/player-taking-damage.mp3',
  '/sounds/player-taking-damage-2.mp3',
  '/sounds/player-taking-damage-3.mp3',
  '/sounds/player-taking-damage-4.mp3',
  '/sounds/relic-obtained.mp3',
  '/sounds/space-synth.mp3',
  '/sounds/success.mp3',
  '/sounds/treasure-chest-slice-open.mp3',
  '/sounds/treasure_chest_reveal.mp3',
  '/sounds/transition-to-next-page.mp3',
  '/sounds/welcome-to-single-player.mp3',
  '/sounds/whoosh-cinematic-sound.mp3',
  '/sounds/whoosh-transition-sound.mp3',
  '/sounds/deploy-beacon.mp3',
  '/sounds/decoy-intercept.mp3',
  '/sounds/shield-charge-up.mp3',
  '/sounds/shield-used.mp3',
  '/sounds/sabotage-board.mp3',
  '/sounds/interference.mp3',
  '/sounds/recharge-ability.mp3',
  '/sounds/slowdown-time.mp3',
  '/sounds/menu-glitch-select-option.mp3',
  '/sounds/spell-casting.mp3',
  '/sounds/glitch-sound.mp3',
  '/sounds/short-energy-beam-shot.mp3',
  '/sounds/hero-skill-attack.mp3',
  '/sounds/rock-smash.mp3',
  '/sounds/instant-explosion-attack.mp3',
  '/sounds/last-stand.mp3',
  '/sounds/new-item-collected.mp3',
  '/sounds/collect-shards.mp3',
  '/sounds/rpg-bubble-power-up.mp3',
  '/sounds/sound_effect_misc_4.mp3',
  '/sounds/minion-appears.mp3',
  '/sounds/minion-appears-2.mp3',
  '/sounds/minion-appears-3.mp3',
  '/sounds/minion-appears-4.mp3',
  '/sounds/minion-appears-6.mp3',
  '/sounds/minion-appears-7.mp3',
  '/sounds/minion-appears-8.mp3',
  '/sounds/minion-appears-9.mp3',
  '/sounds/punch-impact-hit.mp3',
  '/sounds/massive-attack.mp3',
  '/sounds/core-charging-attack.mp3',
  '/sounds/stop-time-explosion.mp3',
  '/sounds/enter-portal-6.mp3',
  '/sounds/die-pre-entering-portal.mp3',
  '/sounds/overload-on.mp3',
  '/sounds/overload-off.mp3',
];

export const WARM_SOUND_EFFECTS = [
  CORE_PORTAL_ENTRY_SOUND,
  WARDEN_PORTAL_ENTRY_SOUND,
  WARDEN_ARRIVAL_SOUND,
  CORE_FIGHT_INTRO_SOUND,
  CORE_DIE_THROW_SOUND,
  '/sounds/glitch_core_misc_sound_2.mp3',
  ...NON_LETHAL_ATTACK_SOUNDS,
  ...Object.values(GUARDIAN_ATTACK_SOUNDS).flat(),
  '/sounds/attack.mp3',
  '/sounds/menu-select.mp3',
  '/sounds/menu-select-2.mp3',
  '/sounds/menu-select-3.mp3',
  '/sounds/dice-roll-throw.mp3',
  '/sounds/low-frequency-dice-impact.mp3',
  '/sounds/charged-laser-sound.mp3',
  '/sounds/deploy-beacon.mp3',
  '/sounds/decoy-intercept.mp3',
  '/sounds/shield-charge-up.mp3',
  '/sounds/shield-used.mp3',
  '/sounds/sabotage-board.mp3',
  '/sounds/interference.mp3',
  '/sounds/recharge-ability.mp3',
  '/sounds/slowdown-time.mp3',
  '/sounds/menu-glitch-select-option.mp3',
  '/sounds/spell-casting.mp3',
  '/sounds/glitch-sound.mp3',
  '/sounds/short-energy-beam-shot.mp3',
  '/sounds/hero-skill-attack.mp3',
  '/sounds/last-stand.mp3',
  '/sounds/new-item-collected.mp3',
  '/sounds/collect-shards.mp3',
  '/sounds/rpg-bubble-power-up.mp3',
  '/sounds/sound_effect_misc_4.mp3',
  '/sounds/minion-appears.mp3',
  '/sounds/minion-appears-2.mp3',
  '/sounds/minion-appears-3.mp3',
  '/sounds/minion-appears-4.mp3',
  '/sounds/minion-appears-6.mp3',
  '/sounds/minion-appears-7.mp3',
  '/sounds/minion-appears-8.mp3',
  '/sounds/minion-appears-9.mp3',
  '/sounds/punch-impact-hit.mp3',
  '/sounds/massive-attack.mp3',
  '/sounds/core-charging-attack.mp3',
  '/sounds/stop-time-explosion.mp3',
  '/sounds/enter-portal-6.mp3',
  '/sounds/die-pre-entering-portal.mp3',
  '/sounds/overload-on.mp3',
  '/sounds/overload-off.mp3',
];
